<template>
    <div class="flex-box2">
        <div class="icon-class">
            <i class="el-icon-arrow-up firm-clickable" @click="up(1)"></i>
            <el-input v-model.number="input" type="number" min="0" max="24" oninput="validity.valid ||(value ='');"
                style="width: 60px;height: 30px;" @blur="blur" />
            <i class="el-icon-arrow-down firm-clickable" @click="down(1)"></i>
        </div>
        <div style="margin:0 14px 7px 10px;">:</div>
        <div class="icon-class">
            <i class="el-icon-arrow-up firm-clickable" @click="up(2)"></i>
            <el-input v-model.number="input2" type="number" min="0" max="59" oninput="validity.valid ||(value ='');"
                style="width: 55px;height: 30px;" @blur="blur" />
            <i class="el-icon-arrow-down firm-clickable" @click="down(2)"></i>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            hourList: [],
            minuteList: [],
            input: 18,
            input2: '00'
        };
    },
    created() {
        for (let index = 0; index < 25; index++) {
            this.hourList.push(index)
        }
        for (let index = 0; index < 60; index++) {
            this.minuteList.push(index)
        }
    },

    methods: {
        blur() {
            if (this.input < 10) {
                this.input = '0' + Number(this.input)
            }
            this.$emit('getInput',this.input)
            if (this.input2 < 10) {
                this.input2 = '0' + Number(this.input2)
            }
            this.$emit('getInput2',this.input2)
        },
        up(val) {
            if (val == 1) {
                this.input++
                if (this.input < 10) {
                    this.input = '0' + Number(this.input)
                }
                if(this.input > 24){
                    this.input = 24
                }
                this.$emit('getInput',this.input)
            }else{
                this.input2++
                if (this.input2 < 10) {
                    this.input2 = '0' + Number(this.input2)
                }
                if(this.input2 > 60){
                    this.input2 = 60
                }
                this.$emit('getInput2',this.input2)
            }
        },
        down(val){
            if (val == 1) {
                this.input--
                if(this.input < 0){
                    this.input = 0
                }
                if (this.input < 10) {
                    this.input = '0' + Number(this.input)
                }
                this.$emit('getInput',this.input)
                
            }else{
                this.input2--
                if(this.input2 < 0){
                    this.input2 = 0
                }
                if (this.input2 < 10) {
                    this.input2 = '0' + Number(this.input2)
                }
                this.$emit('getInput2',this.input2)
            }
        }
    }
}
</script>

<style lang="less" scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

::v-deep input[type="number"] {
    -moz-appearance: textfield;
}

/deep/.el-input__inner {
    border: 0 !important;
    font-size: 24px;
    width: 60px;
    height: 30px;
    color: #333;
}

.icon-class {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 15px;
    color: #ADADAD;

    i {
        cursor: pointer;
    }
}
</style>